import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import GetAppIcon from "@material-ui/icons/GetApp"
import StarIcon from "@material-ui/icons/Star"
import { getStatusList } from "actions/Clerk/applicants"
import classnames from "clsx"
import ApplicantData from "components/Clerk/ApplicantData"
import AvatarComponent from "components/Common/Avatar"
import ButtonRounded from "components/Common/ButtonRounded"
import AppContext from "contexts/App"
import MessagesContext from "contexts/Messages"
import { useEffect, useState } from "react"
import { useContext } from "react"
import { useQuery, useQueryClient } from "react-query"
import { useHistory } from "react-router-dom"

import useStyles from "./styles"

// This Dialog opens inside of a BoardView when you click on an applicant's name.
// Goes directly to tthe selected application to the currently viewed board
const ApplicantDialog = () => {
  const queryClient = useQueryClient()
  const classes = useStyles()
  const history = useHistory()
  const { dialogs, openDialog, closeDialog, openSnackBar, isClerk, authUser } =
    useContext(AppContext)
  const { createThreadMutation, refetchThreads } = useContext(MessagesContext)
  const thisDialog = dialogs?.["applicantDialog"] || {}
  const { open = false, data = {} } = thisDialog
  const [applicationFavorite, setApplicationFavorited] = useState()
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState()
  //state to hide applicant info and show or more experience or more expertise or more interests
  const [hide, setHide] = useState(false)
  const [moreData, setMoreData] = useState({})

  let applicant = data?.selected
  let mutation = data?.mutation
  let favoriteMutation = data?.favoriteMutation
  let boardId = data?.boardId
  let statusMutation = data?.statusMutation
  let openPdfMutation = data?.openPdfMutation
  let applicationId = data?.selected?.board_application_id

  //board is bool prop passed only if coming from Board/ApplicantList instead of Applicants sidebar
  let board = data?.board

  const [applicantData, setApplicantData] = useState({})
  const [loading, setLoading] = useState(true)

  const navigateToChat = async () => {
    // will ultimately handle going to chat with this citizen's id OR creaete new chat
    // for now basic routing to general messages
    try {
      const response = await createThreadMutation.mutateAsync({
        user_id: applicant.user_id,
        entity_id: authUser.entity_id,
        admin: isClerk,
      })
      await refetchThreads()

      history.push(`/messages/${response.thread_id}`)
    } catch (error) {
      throw new Error(error)
    }

    handleClose()
  }

  const handleClose = () => {
    closeDialog("applicantDialog")
    setTimeout(() => {
      setHide(false)
      setMoreData({})
      setLoading(true)
    }, 200)
  }

  const handleOpenDialog = () => {
    let data = {
      applicationId: applicationId,
      name: `${applicant?.first_name}_${applicant?.last_name}`.toLowerCase(),
    }
    //need Application.id, not applicant.id
    openDialog("downloadApplicantProfile", data)
  }

  const handleCloseStatus = (status) => {
    let data = {
      boardId: boardId,
      applicationId: applicant?.board_application_id,
      status_id: status.id,
    }
    statusMutation
      .mutateAsync(data)
      .then((res) => {
        setAnchorEl(null)
        setSelectedStatus({ label: status.status, id: status.id })
        openSnackBar({ message: "Application status updated" })
        //update board applicants query
        return queryClient.setQueryData(
          ["boardApplicants", boardId],
          (oldState) => {
            // let newApplicants
            let newActive = oldState.active_applications
            let newPrevious = oldState.previous_applications
            if (applicant.active === 1) {
              newActive = oldState.active_applications.map((x) => {
                if (
                  x.board_application_id === applicant?.board_application_id
                ) {
                  let data = x
                  x.status_id = res.status_id
                  x.status = status.status
                  return data
                } else {
                  return x
                }
              })
              return {
                active_applications: newActive,
                previous_applications: newPrevious,
              }
            } else {
              newPrevious = oldState.previous_applications.map((x) => {
                if (
                  x.board_application_id === applicant?.board_application_id
                ) {
                  let data = x
                  x.status_id = res.status_id
                  x.status = status.status
                  return data
                } else {
                  return x
                }
              })
              return {
                active_applications: newActive,
                previous_applications: newPrevious,
              }
            }
          }
        )
      })
      .catch((err) => {
        console.log(err)
        openSnackBar({ message: "Error updating application status" })
      })
  }

  useEffect(() => {
    let applicantId = applicant?.board_application_id
    mutation
      ?.mutateAsync(applicantId)
      .then((res) => {
        setApplicantData(res)
        setLoading(false)
        setApplicationFavorited(res.applicant?.favorited)
        setSelectedStatus({
          label: res?.applicant?.status,
          id: res?.applicant?.status_id,
        })
        //if the applicant is applied change to viewes when the clerk open this dialog
        if (res?.applicant?.status_id === 1) {
          let status = { status: "Viewed", id: 2 }
          handleCloseStatus(status)
        }
      })
      .catch((err) => {
        setLoading(false)
      })
  }, [mutation])

  const toggleFavorite = () => {
    let data = {
      boardId: boardId,
      applicationId: applicantData?.applicant?.board_application_id,
    }
    favoriteMutation
      .mutateAsync(data)
      .then((res) => {
        setApplicationFavorited(res.favorited ? true : false)
        openSnackBar({ message: "Favorite application updated" })
        //update board applicants query
        queryClient.setQueryData(["boardApplicants", boardId], (oldState) => {
          let newApplicants = oldState.map((x) => {
            if (
              x.board_application_id ===
              applicantData?.applicant?.board_application_id
            ) {
              let data = x
              x.favorited = res.favorited ? true : false
              return data
            } else {
              return x
            }
          })
          return newApplicants
        })
      })
      .catch((err) => {
        openSnackBar({ message: "Error updating favorite application" })
      })
  }

  const openStatus = (event) => {
    setAnchorEl(event.currentTarget)
  }
  //populate status dropdown
  const { data: statusOptions, isLoading: statusOptionsLoading } = useQuery(
    "status",
    getStatusList
  )

  const downloadPdf = (id) => {
    openPdfMutation
      ?.mutateAsync(id)
      .then((res) => {
        window.location.href = res?.url
      })
      .catch((err) => {
        openSnackBar({ message: "Error opening resume" })
      })
  }

  const handleBack = () => {
    if (hide) {
      setHide(false)
    }
  }

  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.paper }}>
      <DialogContent className={classes.content}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100%"
            marginTop="50%"
            marginBottom="50%"
          >
            <CircularProgress size={30} />
          </Box>
        ) : (
          <>
            <Box display="flex" alignItems="center">
              <AvatarComponent
                className={classes.avatar}
                user={applicantData?.applicant}
              />
              <Box
                display="flex"
                flexDirection="column"
                flexGrow={1}
                marginLeft="10px"
                justifyContent="flex-start"
              >
                <Typography className={classes.name} variant="h5">
                  {board
                    ? applicant?.first_name + " " + applicant?.last_name
                    : applicant?.name}
                </Typography>
                <Typography>
                  {applicantData?.applicant?.city}
                  {", "}
                  {applicantData?.applicant?.state}
                  {", "}
                  {applicantData?.applicant?.zip_code}
                </Typography>
              </Box>

              <Box display="flex" flexDirection="column">
                <ButtonRounded
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => navigateToChat()}
                >
                  Start Chat
                </ButtonRounded>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="flex-end"
              width="100%"
              alignItems="center"
            >
              <IconButton
                className={classes.downloadButton}
                onClick={handleOpenDialog}
              >
                <GetAppIcon className={classes.colorPink} />
              </IconButton>
              <IconButton
                onClick={toggleFavorite}
                className={classes.starButton}
              >
                <StarIcon
                  className={
                    applicationFavorite ? classes.favorite : classes.unfavorite
                  }
                />
              </IconButton>
              <ButtonRounded
                className={classnames(classes.root, {
                  [classes.appliedChip]: selectedStatus?.id === 1,
                  [classes.viewedChip]: selectedStatus?.id === 2,
                  [classes.appointedChip]: selectedStatus?.id === 3,
                  [classes.deferredChip]: selectedStatus?.id === 4,
                  [classes.noLongerConsiderationChip]: selectedStatus?.id === 5,
                  [classes.otherChip]: selectedStatus?.id > 5,
                })}
                onClick={openStatus}
                aria-controls={open ? "simple-menu" : undefined}
                aria-haspopup="true"
                disabled={selectedStatus?.id === 4}
                variant="contained"
              >
                {selectedStatus?.label} <ExpandMoreIcon />
              </ButtonRounded>

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                // onClose={handleClose}
              >
                {statusOptions
                  ?.filter((x) => x.id !== 1 && x.id !== 4 && x?.id !== 7)
                  ?.map((s) => {
                    return (
                      <MenuItem key={s.id} onClick={() => handleCloseStatus(s)}>
                        {s.status}
                      </MenuItem>
                    )
                  })}
              </Menu>
            </Box>
            {/* component reused in applicants page when open details*/}
            <ApplicantData
              applicantData={applicantData}
              setHide={setHide}
              setMoreData={setMoreData}
              downloadPdf={downloadPdf}
              moreData={moreData}
              openPdfMutation={openPdfMutation}
              board={board}
              hide={hide}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          {hide && (
            <ButtonRounded
              color="primary"
              variant="contained"
              onClick={handleBack}
              type="button"
              className={classes.backButton}
            >
              Back
            </ButtonRounded>
          )}
          <ButtonRounded
            color="primary"
            variant="outlined"
            onClick={handleClose}
            type="button"
          >
            Close
          </ButtonRounded>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default ApplicantDialog
